// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-scroll-container {
  scrollbar-width: thin;
  scrollbar-color: #775fff;
}
.custom-scroll-container::-webkit-scrollbar {
  width: 0px;
}

:focus-visible {
  outline: none !important;
}

.css-9425fu-MuiOutlinedInput-notchedOutline {
  top: -6px !important;
}

@media (min-width: 900px) {
  .css-g2epng-MuiGrid-root {
    gap: 4px;
    align-items: baseline !important;
  }
}
@media (min-width: 1200px) {
  .css-urj5pv-MuiGrid-root {
    flex-basis: 46.666667% !important;
    flex-grow: 0;
    max-width: 50.666667% !important;
  }
}
.css-1vlv06b-MuiInputBase-root-MuiOutlinedInput-root {
  height: 45px !important;
}

.css-9m4evr-MuiInputBase-root-MuiOutlinedInput-root {
  height: 45px !important;
}

.css-f34qqq-MuiAutocomplete-root .MuiOutlinedInput-root {
  height: 45px !important;
}

.border-none {
  border: 1px green !important;
}

@media (min-width: 1200px) {
  .css-urj5pv-MuiGrid-root {
    flex-basis: 46.666667% !important;
    flex-grow: 0;
    max-width: 50.666667% !important;
  }
}
.css-1vlv06b-MuiInputBase-root-MuiOutlinedInput-root {
  height: 45px !important;
}

.css-9m4evr-MuiInputBase-root-MuiOutlinedInput-root {
  height: 45px !important;
}

.css-f34qqq-MuiAutocomplete-root .MuiOutlinedInput-root {
  height: 45px !important;
}

.css-nheat6-MuiList-root-MuiMultiSectionDigitalClockSection-root:not(:first-of-type) {
  border-left: unset !important;
}

.css-1916zh5-MuiList-root-MuiMultiSectionDigitalClockSection-root:not(:first-of-type) {
  border-left: unset !important;
}

.css-lk6str-MuiList-root-MuiMultiSectionDigitalClockSection-root:not(:first-of-type) {
  border-left: unset !important;
}

.css-pefsdu-MuiList-root-MuiMultiSectionDigitalClockSection-root:not(:first-of-type) {
  border-left: unset !important;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/components/ui/create-activity/create-activity-main-sec/create-actvity-body/create-activity-body.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,wBAAA;AACF;AACE;EACE,UAAA;AACJ;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE;IACE,QAAA;IACA,gCAAA;EACF;AACF;AACA;EACE;IAGE,iCAAA;IAIA,YAAA;IACA,gCAAA;EACF;AACF;AAEA;EACE,uBAAA;AAAF;;AAEA;EACE,uBAAA;AACF;;AACA;EACE,uBAAA;AAEF;;AAAA;EACE,4BAAA;AAGF;;AAAA;EACE;IAGE,iCAAA;IAIA,YAAA;IACA,gCAAA;EAGF;AACF;AAAA;EACE,uBAAA;AAEF;;AAAA;EACE,uBAAA;AAGF;;AADA;EACE,uBAAA;AAIF;;AAFA;EACE,6BAAA;AAKF;;AAHA;EACE,6BAAA;AAMF;;AAJA;EACE,6BAAA;AAOF;;AALA;EACE,6BAAA;AAQF","sourcesContent":[".custom-scroll-container {\n  scrollbar-width: thin;\n  scrollbar-color: #775fff;\n\n  &::-webkit-scrollbar {\n    width: 0px;\n  }\n}\n:focus-visible {\n  outline: none !important;\n}\n\n.css-9425fu-MuiOutlinedInput-notchedOutline {\n  top: -6px !important;\n}\n\n@media (min-width: 900px) {\n  .css-g2epng-MuiGrid-root {\n    gap: 4px;\n    align-items: baseline !important;\n  }\n}\n@media (min-width: 1200px) {\n  .css-urj5pv-MuiGrid-root {\n    -webkit-flex-basis: 41.666667%;\n    -ms-flex-preferred-size: 41.666667%;\n    flex-basis: 46.666667% !important;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 50.666667% !important;\n  }\n}\n\n.css-1vlv06b-MuiInputBase-root-MuiOutlinedInput-root {\n  height: 45px !important;\n}\n.css-9m4evr-MuiInputBase-root-MuiOutlinedInput-root {\n  height: 45px !important;\n}\n.css-f34qqq-MuiAutocomplete-root .MuiOutlinedInput-root {\n  height: 45px !important;\n}\n.border-none {\n  border: 1px green !important;\n}\n\n@media (min-width: 1200px) {\n  .css-urj5pv-MuiGrid-root {\n    -webkit-flex-basis: 41.666667%;\n    -ms-flex-preferred-size: 41.666667%;\n    flex-basis: 46.666667% !important;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 50.666667% !important;\n  }\n}\n\n.css-1vlv06b-MuiInputBase-root-MuiOutlinedInput-root {\n  height: 45px !important;\n}\n.css-9m4evr-MuiInputBase-root-MuiOutlinedInput-root {\n  height: 45px !important;\n}\n.css-f34qqq-MuiAutocomplete-root .MuiOutlinedInput-root {\n  height: 45px !important;\n}\n.css-nheat6-MuiList-root-MuiMultiSectionDigitalClockSection-root:not(:first-of-type) {\n  border-left: unset !important;\n}\n.css-1916zh5-MuiList-root-MuiMultiSectionDigitalClockSection-root:not(:first-of-type) {\n  border-left: unset !important;\n}\n.css-lk6str-MuiList-root-MuiMultiSectionDigitalClockSection-root:not(:first-of-type) {\n  border-left: unset !important;\n}\n.css-pefsdu-MuiList-root-MuiMultiSectionDigitalClockSection-root:not(:first-of-type) {\n  border-left: unset !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
